import { Box, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseTable from "../../../../components/table/BaseTable";
import {
    useAgreementNotificationList
} from "../../../../services/agreementsService";
import InfoIcon from "@mui/icons-material/Info";

import DateService from "../../../../services/dateService";
import { useDialogBetter } from "../../../../hooks/useDialogBetter";
import { SendEmailDialog } from "../../../../components/dialog/EmailSender";


export const AgreementNotificationTab = (props) => {
    const { t } = useTranslation()
    const { agreement, readOnly } = props;

    const { openDialog: openSendEmailDialog, closeDialog: closeSendEmailDialog } = useDialogBetter();

    const handleOpenEmailDialog = (emailData) => {
        openSendEmailDialog({
            Component: SendEmailDialog,
            componentProps: {
                recipientEmails: emailData.to || [],
                initialSubject: emailData?.subject,
                initialBody: emailData?.body,
                onSendEmail: null,
                title: t("agreements.SendNotificationButton.notificationSend"),
                showDueDateField: emailData.due_date,
                initialDueDate: emailData.due_date,
                readOnly: true
            },
        });
    };

    const HEADERS = [
        t("agreements.notification.notification_name"),
        t("agreements.notification.notification_send_date"),
        t("agreements.notification.notification_send_user"),
        t("agreements.notification.notification_content"),
    ];

    const { data: notifications, isLoading } = useAgreementNotificationList(agreement.id, {select: (data) =>
            data?.map((notification) => {
                return {
                    rowId: notification.id,
                    data: [
                        notification.notification_name,
                        notification.notification_send_date,
                        notification.notification_send_user,
                        notification.notification_send_data ? <IconButton
                                color="primary"
                                sx={{ padding: "5px" }}
                                onClick={()=>handleOpenEmailDialog(notification.notification_send_data)}
                            >
                            <InfoIcon fontSize="medium" />
                        </IconButton> : null
                    ],
                };
            }) || [],
        }
    )

    return (
        <Box display="flex" justifyContent="center">
            <Box sx={{ width: "80%" }}>
                <BaseTable 
                    
                    stickyHeader={true}
                    headers={HEADERS}
                    rows={notifications || []}
                    showEditButton={false}
                    showDeleteButton={false}
                    sortable={false}
                    // ensure no columns are hidden
                    hiddenColumns={[]}
                    // no row selection for this static table
                    selectedRows={[]}
                />
            </Box>
        </Box>
    );
}